// extracted by mini-css-extract-plugin
export default {"errorLink":"ErrorBoundary__errorLink__Jzubj"};